import { callsAPI, meetingsAPI, tasksAPI } from '../../api/crmActivities';

const state = {
  calls: [],
  meetings: [],
  tasks: [],
  uiFlags: {
    isFetchingCalls: false,
    isFetchingMeetings: false,
    isFetchingTasks: false,
  },
};

const getters = {
  getCalls: $state => $state.calls,
  getMeetings: $state => $state.meetings,
  getTasks: $state => $state.tasks,
  getUIFlags: $state => $state.uiFlags,
  getAllActivities: $state => {
    const tagged = [
      ...$state.calls.map(c => ({ ...c, activityType: 'call' })),
      ...$state.meetings.map(m => ({ ...m, activityType: 'meeting' })),
      ...$state.tasks.map(t => ({ ...t, activityType: 'task' })),
    ];
    return tagged.sort((a, b) => {
      const dateA = a.date_start || a.date_end || a.created_at || '';
      const dateB = b.date_start || b.date_end || b.created_at || '';
      return new Date(dateA) - new Date(dateB);
    });
  },
};

const mutations = {
  SET_CALLS($state, calls) { $state.calls = calls; },
  SET_MEETINGS($state, meetings) { $state.meetings = meetings; },
  SET_TASKS($state, tasks) { $state.tasks = tasks; },
  ADD_CALL($state, call) { $state.calls.push(call); },
  ADD_MEETING($state, meeting) { $state.meetings.push(meeting); },
  ADD_TASK($state, task) { $state.tasks.push(task); },
  DELETE_CALL($state, id) { $state.calls = $state.calls.filter(c => c.id !== id); },
  DELETE_MEETING($state, id) { $state.meetings = $state.meetings.filter(m => m.id !== id); },
  DELETE_TASK($state, id) { $state.tasks = $state.tasks.filter(t => t.id !== id); },
  SET_UI_FLAG($state, flag) { $state.uiFlags = { ...$state.uiFlags, ...flag }; },
};

const actions = {
  async fetchCalls({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetchingCalls: true });
    try {
      const { data } = await callsAPI.get(params);
      commit('SET_CALLS', data.payload || data);
    } finally { commit('SET_UI_FLAG', { isFetchingCalls: false }); }
  },
  async fetchMeetings({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetchingMeetings: true });
    try {
      const { data } = await meetingsAPI.get(params);
      commit('SET_MEETINGS', data.payload || data);
    } finally { commit('SET_UI_FLAG', { isFetchingMeetings: false }); }
  },
  async fetchTasks({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetchingTasks: true });
    try {
      const { data } = await tasksAPI.get(params);
      commit('SET_TASKS', data.payload || data);
    } finally { commit('SET_UI_FLAG', { isFetchingTasks: false }); }
  },
  async createCall({ commit }, payload) {
    const { data } = await callsAPI.create(payload);
    commit('ADD_CALL', data.payload || data);
    return data;
  },
  async createMeeting({ commit }, payload) {
    const { data } = await meetingsAPI.create(payload);
    commit('ADD_MEETING', data.payload || data);
    return data;
  },
  async createTask({ commit }, payload) {
    const { data } = await tasksAPI.create(payload);
    commit('ADD_TASK', data.payload || data);
    return data;
  },
  async deleteCall({ commit }, id) {
    await callsAPI.delete(id);
    commit('DELETE_CALL', id);
  },
  async deleteMeeting({ commit }, id) {
    await meetingsAPI.delete(id);
    commit('DELETE_MEETING', id);
  },
  async deleteTask({ commit }, id) {
    await tasksAPI.delete(id);
    commit('DELETE_TASK', id);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
